import React, { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { FeatureMapping } from '@loyalty/shared-common';
import { Loader } from '../shared/layout/Loader';
import { useAccounts } from '../accounts/AccountsContext';
import { useAuth } from '../auth/context/AuthenticationProvider';

interface FeaturesContextInterface {
  features: FeatureMapping<boolean>;
  setFeatures: (features: FeatureMapping<boolean>) => void;
}

export const FeaturesContext = createContext<FeaturesContextInterface>({} as any);

export function useFeatures() {
  return useContext(FeaturesContext);
}

export function FeaturesProvider({ children }: { children: ReactNode }) {
  const [features, setFeatures] = useState<FeatureMapping<boolean>>(undefined as any);
  const { currentAccount } = useAccounts();
  const { user } = useAuth();

  const context = useMemo(
    () => ({
      features,
      setFeatures,
    }),
    [features],
  );

  useEffect(() => {
    setFeatures(
      !!user && !!currentAccount
        ? (user.features as Record<string, any>)?.['super_admin']?.featureMap ||
            (user.features as Record<string, any>)?.[currentAccount.id]?.featureMap
        : undefined,
    );
  }, [currentAccount, user]);

  if (!features) {
    return <Loader />;
  }

  return <FeaturesContext.Provider value={context}>{children}</FeaturesContext.Provider>;
}
